import { Survey } from '@goldcast/api/backend';

import { State } from './types';

const getters = {
  getSurveys(state: State): Array<Survey> {
    return state.surveys;
  },
  isSurveysLoading(state: State): Boolean {
    return state.isSurveysLoading;
  },
  isDeleteSurveyLoading(state: State): Boolean {
    return state.isDeleteSurveyLoading;
  }
};

export default getters;
